// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true. Contract: docs/api-contracts/health-encyclopedia.md.

import type { HealthEncyclopediaApi } from '../types/health-encyclopedia.types';
import { healthEncyclopediaHttpApi } from './health-encyclopedia.api';
import { healthEncyclopediaMockApi } from './health-encyclopedia.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const healthEncyclopediaApi: HealthEncyclopediaApi = useMock
  ? healthEncyclopediaMockApi
  : healthEncyclopediaHttpApi;
